<template>
    <div class="sr-platform-manager">
         <Card :padding="10" shadow title="查询条件" class="bt-card">
            <div class="search-con search-con-top">
                <Input v-model.trim="key" clearable @on-enter="searchSrPlatformList" @on-clear="searchSrPlatformList" placeholder="名称" class="search-input"/>
                <Button type="primary" icon="md-search" @click="searchSrPlatformList">搜索</Button>
            </div>
        </Card>
        
        <Card :padding="10" title="科研平台列表" shadow>
            <p slot="extra">
               <Button @click="handleAddSrPlatform" type="primary">新增</Button>
            </p>
            <Table :columns="columns" border :data="list" stripe></Table>
            <Page :total="total" :current="page" :page-size="size" @on-change="handlePageChange" @on-page-size-change='handlePageSize' show-total show-elevator show-sizer class-name="bt-page"/>
        </Card>

        <Modal
            v-model="modal"
            :title="editSrPlatform.id == 0 ? '新增科研平台' : '编辑科研平台'"
            @on-visible-change="resetForm"
            :width="600">
            <Form ref="editSrPlatform" :model="editSrPlatform" :label-width="100">
                <FormItem label="名称" prop="name" :rules="{required: true, message: '名称不能为空'}">
                   <Input v-model.trim="editSrPlatform.name" placeholder="请输入名称"></Input>
                </FormItem>
                <FormItem label="平台类型" prop="types" :rules="{required: true, message: '平台类型不能为空'}">
                    <Select v-model="editSrPlatform.types" placeholder="请选择平台类型">
                        <Option v-for="item in typeList" :key="item" :value="item">{{item}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="图片" prop="pic" :rules="{required: true, message: '图片不能为空'}">
                    <CustomUpload v-model="editSrPlatform.pic"></CustomUpload>
                </FormItem>
                <FormItem label="介绍" prop="introduce" :rules="{required: true, message: '介绍不能为空'}">
                    <editor v-model="editSrPlatform.introduce"></editor>
                </FormItem>
                <FormItem label="排序码" prop="orders" :rules="{required: true, min: 0,type: 'number',message: '排序码不能为空', trigger: 'change'}">
                   <InputNumber v-model="editSrPlatform.orders" placeholder="请输入排序码"></InputNumber>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="modal=false">取消</Button>
                <Button type="primary" size="large" @click="handleSrPlatformSubmit">确定</Button>
            </div>
        </Modal>

        <Modal
            v-model="auditBackModal"
            title="审核打回">
            <Form ref="auditBackValue" :model="auditBackValue" :label-width="100">
                <FormItem label="原因" prop="reason" :rules="{required: true, message: '原因不能为空'}">
                   <Input v-model.trim="auditBackValue.reason" maxlength="500" show-word-limit type="textarea" placeholder="请输入原因"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="auditBackModal=false">取消</Button>
                <Button type="primary" size="large" @click="handleAuditBackSubmit">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import {renderShowImage,formatDate} from '@/utils';
import editor from '@/components/common/Editor';

export default {
    name: 'srPlatformManager',
    data(){
        return {
            key: '',
            typeList: ['重点实验室','院士工作站','科技公共服务平台','工程技术研究中心','概念验证中心','中试平台','人才定制实验室'],
            list: [],
            page: 1,
            size: 20,
            total: 1,
            columns:[{
              key: 'id',
              title: 'ID',
              align: 'center'
           },{
              key: 'name',
              title: '名称',
              tooltip: true
           },{
              key: 'pic',
              title: '图片',
              align: 'center',
              render: renderShowImage
           },{
              key: 'types',
              title: '平台类型',
              align: 'center'
           },{
              key: 'orders',
              title: '排序码',
              align: 'center'
           },{
              key: 'status',
              title: '审核状态',
              align: 'center',
              render: (h,{row,index})=>{
                if(row.status == 0){
                    return h('Tag',{props: {color: 'default'}},'待审核');
                }else if(row.status == 1){
                    return h('Tag',{props: {color: 'primary'}},'审核通过');
                }else {
                    return h('Tag',{props: {color: 'error'},
                        nativeOn: {
                            click: () => {
                                this.lookAuditBackReason(index);
                            }
                        }
                    },'审核失败');
                }
             }
           },{
              key: 'createTime',
              title: '创建时间',
              align: 'center',
              render: (h,{row})=>{
                  return h('span',formatDate(row.createTime,'yyyy-MM-dd hh:mm:ss'));
              }
           },{
              key: 'modifyTime',
              title: '修改时间',
              align: 'center',
              render: (h,{row})=>{
                  return h('span',formatDate(row.modifyTime,'yyyy-MM-dd hh:mm:ss'));
              }
           },{
              key: 'option',
              title: '操作',
              minWidth: 120,
              render: (h, {row,index}) => {
                 let data = [];
                 if(row.status != 1){
                     data.push(h('Button',{
                        props: {type: 'info',size: 'small'},
                        style: {marginRight: '5px'},
                        on: {
                            click: () => {
                                this.handleEditSrPlatformStatus(index,1);
                            }
                        },
                        directives:[{
                            name: 'permission',
                            value: 'srPlatform:audit'
                        }]
                    }, "审核通过"));
                 }
                 if(row.status != 2){
                    data.push(h('Button',{
                        props: {type: 'error',size: 'small'},
                        style: {marginRight: '5px'},
                        on: {
                            click: () => {
                                this.handleEditSrPlatformStatus(index,2);
                            }
                        },
                        directives:[{
                            name: 'permission',
                            value: 'srPlatform:audit'
                        }]
                    }, "审核打回"));
                 }
                 data.push(h('Button',{
                        props: {type: 'success',size: 'small'},
                        style: {marginRight: '5px'},
                        on: {
                            click: () => {
                                this.handleEditSrPlatform(index);
                            }
                        }
                    }, "编辑"));
                 data.push(h('Button',{
                        props: {type: 'error',size: 'small'},
                        style: {marginRight: '5px'},
                        on: {
                            click: () => {
                                this.handleDeleteSrPlatform(index);
                            }
                        }
                    }, "删除"));
                 return h('div', data);
              }
            }],
            modal: false,
            editSrPlatform: {
               id: 0,
               name: '',
               types: '',
               thumbnail: '',
               pic: '',
               introduce: '',
               orders: 0,
               status: 0
            },
            auditBackModal: false,
            auditBackValue: {
                index: 0,
                status: 0,
                reason: ''
            }
        }
    },
    created(){
        this.searchSrPlatformList();
    },
    methods: {
        searchSrPlatformList(){
            this.page = 1;
            this.querySrPlatformList();
        },
        querySrPlatformList(){
            this.$http.post('/api/admin/getSrPlatformList',{
                key: this.key,
                pn: this.page,
                ps: this.size
            }).then(data=>{
                this.list = data.list;
                this.size = data.pageSize;
                this.total = data.total;
            });
        },
        handleAddSrPlatform(){
            this.editSrPlatform.id = 0;
            this.modal = true;
        },
        handleEditSrPlatform(index){
            this.editSrPlatform = Object.assign({},this.list[index]);
            this.modal = true;
        },
        handleSrPlatformSubmit(){
            this.$refs['editSrPlatform'].validate((valid) => {
              if(valid) {
                 let srPlatform = Object.assign({},this.editSrPlatform);
                 this.$http.post('/api/admin/saveSrPlatform',srPlatform).then(()=>{
                    this.$Message.success("操作成功");
                    this.querySrPlatformList();
                    this.modal = false;
                 });
              }
           });
        },
        openAuditBack(id,status){
           this.auditBackValue = {
               id: id,
               status: status,
               reason: ''
           };
           this.auditBackModal = true;
           this.$refs['auditBackValue'].resetFields();
        },
        handleAuditBackSubmit(){
            this.$refs['auditBackValue'].validate((valid) => {
              if(valid) {
                  this.$http.post('api/admin/updateSrPlatformStatus',this.auditBackValue).then(()=>{
                      this.$Message.success("审核打回成功");
                      this.auditBackModal = false;
                      this.querySrPlatformList();
                  });
              }
           });
        },
        handleEditSrPlatformStatus(index,status){
            let srPlatform = this.list[index];
            if(status == 1){
                this.$Modal.confirm({
                    title: '审核操作',
                    content: '确认审核通过吗？',
                    onOk: () => {
                        this.$http.post('api/admin/updateSrPlatformStatus',{id: srPlatform.id,status: 1}).then(()=>{
                            this.$Message.success("审核通过成功");
                            this.querySrPlatformList();
                        });
                    }
                });
            }else if(status == 2){
                this.openAuditBack(srPlatform.id,status);
            }else {
                this.$Message.error("无效状态");
            }
        },
        handleDeleteSrPlatform(index){
            this.$Modal.confirm({
              title: '删除操作',
              content: '确认删除该科研平台吗？',
              onOk: () => {
                 let srPlatform = this.list[index];
                 this.$http.post('api/admin/deleteSrPlatform',{id: srPlatform.id}).then(()=>{
                    this.$Message.success("删除成功");
                    this.querySrPlatformList();
                 });
              }
           });
        },
        lookAuditBackReason(index){
            this.$http.post('api/admin/queryAuditLogReason',{itemId: this.list[index].id,itemType: 4},false).then((data)=>{
                this.$Modal.error({
                    title: '打回原因',
                    content: data
                });
            });
        },
        resetForm(show){
           if(!show) {
              this.$refs.editSrPlatform.resetFields();
              this.editSrPlatform.id = 0;
           }
        },
        handlePageChange(page){
           this.page = page;
           this.querySrPlatformList();
        },
        handlePageSize(size){
           this.size = size;
           this.page = 1;
           this.querySrPlatformList();
        }
    },
    components: {editor}
}
</script>